import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '@/styles/theme';
import { Container } from '@/components/ui/Container';
import { Button } from '@/components/ui/Button';
import { Home } from 'lucide-react';

const NotFoundContainer = styled.div`
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: ${theme.spacing[12]} 0;
`;

const Content = styled.div`
  h1 {
    font-size: ${theme.fontSizes['7xl']};
    color: ${theme.colors.primary.navy};
    margin-bottom: ${theme.spacing[4]};

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.fontSizes['5xl']};
    }
  }

  h2 {
    font-size: ${theme.fontSizes['3xl']};
    color: ${theme.colors.neutral.gray};
    margin-bottom: ${theme.spacing[6]};

    @media (max-width: ${theme.breakpoints.md}) {
      font-size: ${theme.fontSizes['2xl']};
    }
  }

  p {
    color: ${theme.colors.neutral.gray};
    margin-bottom: ${theme.spacing[8]};
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const NotFoundPage = () => {
  return (
    <NotFoundContainer>
      <Container>
        <Content>
          <h1>404</h1>
          <h2>Pagina Niet Gevonden</h2>
          <p>
            De pagina die u zoekt bestaat niet of is verplaatst. Ga terug naar de startpagina om verder te gaan.
          </p>
          <Link to="/">
            <Button size="lg">
              <Home size={20} />
              Terug naar Start
            </Button>
          </Link>
        </Content>
      </Container>
    </NotFoundContainer>
  );
};
